import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { SafeImage } from "./Media";

export const SectionHead = ({ n, label, title, intro, align = "left" }) => (
  <div className={align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
    <p className={`lux-eyebrow mb-5 ${align === "center" ? "text-center" : ""}`}>
      {n && <span className="mr-3 opacity-50">{n}</span>}
      {label}
    </p>
    <h2 className="case-dark-heading">{title}</h2>
    {intro && <p className="mt-6 text-base leading-relaxed text-mist sm:text-lg">{intro}</p>}
  </div>
);

export const PageHero = ({ eyebrow, title, sub, img, conceptImg, alt = "", leftContent, className = "" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imageY = useTransform(scrollYProgress, [0, 1], ["0%", "8%"]);
  const imageScale = useTransform(scrollYProgress, [0, 1], [1.04, 1]);
  return (
    <header ref={ref} className="creative-page-hero">
      <div className="creative-page-paper" aria-hidden="true" />
      {conceptImg && (
        <div className="creative-page-concept-bg" aria-hidden="true">
          <img src={conceptImg} alt="" />
        </div>
      )}
      <div className={`creative-page-shell ${img || leftContent ? "has-media" : "no-media"} ${className}`}>
        {leftContent ? (
          <div className="creative-page-side-content">{leftContent}</div>
        ) : img && (
          <motion.div
            className="creative-page-visual is-photo"
            initial={reduce ? false : { clipPath: "inset(0 100% 0 0)" }}
            whileInView={reduce ? undefined : { clipPath: "inset(0 0% 0 0)" }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          >
            <motion.div className="creative-page-visual-sensor" style={{ y: reduce ? 0 : imageY, scale: reduce ? 1 : imageScale }}>
              <SafeImage
                src={img}
                alt={alt}
                className="h-full w-full object-cover"
                fallbackClassName="h-full w-full"
                loading="eager"
                decoding="async"
              />
            </motion.div>
            <span className="creative-page-visual-index">YUXEL / 01</span>
          </motion.div>
        )}
        <div className="creative-page-copy">
          <p className="creative-kicker">{eyebrow}</p>
          <h1>{title}</h1>
          {sub && <p className="creative-page-sub">{sub}</p>}
        </div>
      </div>
    </header>
  );
};

export const Grain = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-[100] opacity-[0.018] mix-blend-multiply"
    style={{
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
    }}
  />
);
